import React, {Component} from 'react';
import styled from 'styled-components';
import {NotificationManager} from 'react-notifications';
import {v4 as uuid} from 'uuid';

import * as api from '../../lib/api';
import {withUser} from '../../lib/user';
import Loading from '../Loading';

class ImageInput extends Component {
  state = {
    uploading: false,
    result: null
  };

  handleUpload = async e => {
    const {credentials, onChange} = this.props;
    this.setState({uploading: true});

    try {
      const file = (await base64EncodeFile(e.target.files[0])).replace('data:image/jpeg;base64,', '');
      const imageId = uuid();

      await api.uploadImage(imageId, file, credentials);
      this.setState({result: imageId});
      onChange([imageId], true);
    }
    catch (e) {
      NotificationManager.error('Your image was not uploaded. Only JPEG files are supported.');
    }
    finally {
      this.setState({uploading: false});
    }
  }

  render() {
    const {label, question} = this.props;
    const {uploading, result} = this.state;

    if (uploading) {
      return <Loading message="Uploading image..." />;
    }

    if (result) {
      return (
        <div>
          {label && <Label>{label}</Label>}
          <img
            src={`${api.getApiUrl()}/image/${result}`}
            alt={`New answer for ${question.text}`}
            style={{maxHeight: 300, maxWidth: 300}}
          />
        </div>
      );
    }

    return (
      <div>
        {label && <Label>{label}</Label>}
        <input type="file" accept=".jpg,.jpeg" onChange={this.handleUpload} />
      </div>
    );
  }
}

function base64EncodeFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

const Label = styled.label`
  ${props => {
    if (props.labelPosition === 'top') {
      return `
        display: block;
        margin-bottom: 0.5rem;
      `;
    }

    return `
      word-wrap: nowrap;
      margin-right: 1rem;
      display: flex;
      align-items: center;
    `;
  }}
`;

export default withUser(ImageInput);
